import CompanyAffiliation from './CompanyAffiliation';
export { CompanyAffiliation };
export default CompanyAffiliation;
